import React from "react";
import { AnalyticsFilters } from "../types/analytics.types";

interface Preset {
  label: string;
  days: number;
}

const PRESETS: Preset[] = [
  { label: "7D", days: 7 },
  { label: "30D", days: 30 },
  { label: "90D", days: 90 },
];

interface DateRangeBarProps {
  filters: AnalyticsFilters;
  onChange: (filters: AnalyticsFilters) => void;
  onRefresh: () => void;
}

const toInputValue = (date: Date) => date.toISOString().split("T")[0];

const rangeDays = (filters: AnalyticsFilters) =>
  Math.round((filters.endDate.getTime() - filters.startDate.getTime()) / (24 * 60 * 60 * 1000));

export const DateRangeBar: React.FC<DateRangeBarProps> = ({ filters, onChange, onRefresh }) => {
  const applyPreset = (days: number) => {
    const endDate = new Date();
    const startDate = new Date(Date.now() - days * 24 * 60 * 60 * 1000);
    onChange({ ...filters, startDate, endDate });
  };

  const handleStart = (e: React.ChangeEvent<HTMLInputElement>) => {
    const d = new Date(e.target.value);
    if (!isNaN(d.getTime())) onChange({ ...filters, startDate: d });
  };

  const handleEnd = (e: React.ChangeEvent<HTMLInputElement>) => {
    const d = new Date(e.target.value);
    if (!isNaN(d.getTime())) onChange({ ...filters, endDate: d });
  };

  const activeDays = rangeDays(filters);

  return (
    <div className="an-daterange">
      <div className="an-segmented">
        {PRESETS.map((p) => (
          <button
            key={p.label}
            className={`an-segmented-option ${
              activeDays === p.days ? "an-segmented-option--active" : ""
            }`}
            onClick={() => applyPreset(p.days)}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="an-daterange-inputs">
        <input
          type="date"
          className="an-date-input"
          value={toInputValue(filters.startDate)}
          max={toInputValue(filters.endDate)}
          onChange={handleStart}
        />
        <span className="an-daterange-sep">→</span>
        <input
          type="date"
          className="an-date-input"
          value={toInputValue(filters.endDate)}
          min={toInputValue(filters.startDate)}
          max={toInputValue(new Date())}
          onChange={handleEnd}
        />
      </div>
      <button className="an-button" onClick={onRefresh}>
        ↻ Refresh
      </button>
    </div>
  );
};

export default DateRangeBar;
